/* MOREOVER product UX. Event delegation supports Shopify section reloads and variant updates. */
(function () {
  if (window.__mrvrProductUXLoaded) return;
  window.__mrvrProductUXLoaded = true;
  var activeGuide = null, opener = null, previousOverflow = '';
  function enhance(context) {
    var scope = context || document;
    scope.querySelectorAll('[data-mrvr-product-extras]').forEach(function (extras) {
      var info = extras.closest('.product__info-container');
      if (!info) return;
      var description = info.querySelector(':scope > .product__description');
      var buy = info.querySelector('product-form');
      var target = description || buy;
      if (target && target.nextElementSibling !== extras) target.insertAdjacentElement('afterend', extras);
      if (target) info.classList.add('mrvr-extras-ready');
    });
  }
  function selectedSize(guide) {
    var section = guide.closest('.shopify-section');
    var pickers = section ? section.querySelectorAll('.mrvr-size-options') : document.querySelectorAll('.mrvr-size-options');
    for (var i = 0; i < pickers.length; i++) {
      var checked = pickers[i].querySelector('input:checked');
      if (checked) return checked.value;
      var select = pickers[i].querySelector('select');
      if (select) return select.value;
    }
    return 'NOT SELECTED';
  }
  function openGuide(guide, button) {
    if (!guide) return;
    if (activeGuide && activeGuide !== guide) closeGuide();
    activeGuide = guide;
    opener = button;
    var selected = guide.querySelector('[data-mrvr-selected-size]');
    if (selected) selected.textContent = selectedSize(guide);
    previousOverflow = document.body.style.overflow;
    guide.hidden = false;
    document.body.style.overflow = 'hidden';
    guide.querySelector('.mrvr-guide__close').focus();
  }
  function closeGuide() {
    if (!activeGuide) return;
    activeGuide.hidden = true;
    document.body.style.overflow = previousOverflow;
    if (opener && opener.isConnected) opener.focus();
    activeGuide = null;
    opener = null;
  }
  document.addEventListener('click', function (event) {
    var open = event.target.closest('[data-mrvr-guide-open]');
    if (open) {
      event.preventDefault();
      openGuide(document.getElementById(open.getAttribute('data-mrvr-guide-open')), open);
      return;
    }
    if (activeGuide && event.target.closest('[data-mrvr-guide-close]')) {
      event.preventDefault();
      closeGuide();
    }
  });
  document.addEventListener('keydown', function (event) {
    if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('.mrvr-size-trigger--dropdown')) {
      event.preventDefault();
      openGuide(document.getElementById(event.target.getAttribute('data-mrvr-guide-open')), event.target);
      return;
    }
    if (!activeGuide) return;
    if (event.key === 'Escape') { event.preventDefault(); closeGuide(); return; }
    if (event.key !== 'Tab') return;
    var elements = Array.from(activeGuide.querySelectorAll('button:not([disabled]), a[href], summary, input:not([disabled]), [tabindex="0"]')).filter(function (el) { return el.getClientRects().length > 0; });
    if (!elements.length) return;
    var first = elements[0], last = elements[elements.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  document.addEventListener('shopify:section:load', function (event) { enhance(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { if (activeGuide && event.target.contains(activeGuide)) closeGuide(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { enhance(document); }, { once:true });
  else enhance(document);
})();
